import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportCallsData } from "../../../../models/FacilityReportData";
import { LineChart } from "../../../AnalysisCollectionsComponents/CollectionChartArea/LineChart";

interface ICallsSectionProps {
  calls?: FacilityReportCallsData;
  isDownloading: boolean;
}

export const CallsSection: React.FunctionComponent<ICallsSectionProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.callsSection.${key}`);
  const { calls, isDownloading } = props;

  const [timeUnit, setTimeUnit] = useState<"day" | "week" | "month">(
    calls?.time_unit ?? "day"
  );

  if (!calls) {
    return null;
  }

  return (
    <div className="calls-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-calls-section"
      >
        <h2>{t("title")}</h2>
        {calls.ai_summary && <p className="ai-summary">{calls.ai_summary}</p>}
        <LineChart
          chartDetailsData={calls.call_clicks_data}
          usePrevYear={false}
          timeUnit={timeUnit}
          skipLabelTranslation={false}
          setTimeUnit={setTimeUnit}
          showTimeUnitSelect={!isDownloading}
        />
      </div>
    </div>
  );
};
